import $ from "jquery";

$(() => {
  if (document.querySelector('.broker')) {
    $("textarea").attr('rows', 6);

    const resetButton = $('.form-reset');
    resetButton.detach().insertAfter('.wpcf7-response-output');

    $(resetButton).on('click', function() {
      $('.wpcf7-form').trigger('reset');
    });
  }
});